import React from 'react'
import NetFlowsHeatmapChart, { resolveClientSegmentSubtitleLabel } from './NetFlowsHeatmapShared'

const NetFlowsAssetClassAndGeographyHeatmap = (props) => (
  <NetFlowsHeatmapChart
    {...props}
    rowAxisLabel="Geography"
    resolveFilterSubtitleLabel={resolveClientSegmentSubtitleLabel}
    accessibilityPointDescription="{series.xAxis.categories.(x)} asset class net flow {series.yAxis.categories.(y)} geography, {value}."
  />
)

export default NetFlowsAssetClassAndGeographyHeatmap
